export enum methods {
  start = 'start',
  move = 'move',
  end = 'end'
}

const mobileEvent = {
  start: 'touchstart',
  move: 'touchmove',
  end: 'touchend',
};
const desktopEvent = {
  start: 'mousedown',
  move: 'mousemove',
  end: 'mouseup',
};

const eventsMap = 'ontouchend' in document ? mobileEvent : desktopEvent;
export default {
  inserted(el: HTMLElement, { value }: any) {
    ['start', 'move', 'end'].forEach((key: methods) => {
      const handle = value[key];
      if (typeof handle === 'function') {
        el.addEventListener(eventsMap[key], handle, value[`${key}Capture`]);
      }
    });
  },
  unbind(el: HTMLElement, { value }: any) {
    ['start', 'move', 'end'].forEach((key: methods) => {
      const handle = value[key];
      if (typeof handle === 'function') {
        el.removeEventListener(eventsMap[key], handle);
      }
    });
  },
};
